import { setUpBlockCheckoutListeners } from "../../store/storeListeners";
import {WidgetContainer} from '../../components/widgetContainer';
import {select, dispatch} from '@wordpress/data';
import { PAYONEER_STORE_KEY } from "../../store/index";
import $ from 'jquery';
import { getLongId } from "../../store/resolvers";

const payoneerStore = select( PAYONEER_STORE_KEY );

const setUpGatewayContainers = function () {
	if ( !Array.isArray( inpsydeGateways ) ) {
		console.error('window.inpsydeGateways not found')
		return;
	}

	inpsydeGateways.forEach( ( gatewayName ) => {
		addWidgetContainer( gatewayName );
	} );
};

const addWidgetContainer = function ( gatewayId ) {
	wp.hooks.addFilter( `${gatewayId}_checkout_fields`, gatewayId, ( components ) => {
		components.push(
			WidgetContainer
		);
		return components;
	} );

	wp.hooks.addFilter(
		'payoneer-checkout_payment_method_icons',
		'payoneer-checkout',
		(icons) => {
			const activePaymentMethod = payoneerStore.getActivePaymentMethod();
			return activePaymentMethod === 'payoneer-checkout' ? [] : icons
		}
	);
};

const registerPageReloadingOnPaymentDeclined = () => {
	document.addEventListener(
		'DOMContentLoaded',
		() => {
			wp.hooks.addFilter(
				'payoneer.webSdk.onPaymentDeclined',
				'payoneer/blockCheckout',
				() => {
					wp.data.dispatch(PAYONEER_STORE_KEY).releaseOnHoldOrder(
						{
							longId: select( PAYONEER_STORE_KEY ).getLongId(),
							payoneerOrderId: select(PAYONEER_STORE_KEY).getOrderId()
						},
					);
					/**
					 * The following is an extreme solution where a correct solution seemingly does not exist.
					 * As of 02/2025, the WooCommerce checkout entirely depends on a redirectUrl after onCheckoutSuccess().
					 * If there is no redirect, core WC will simply do nothing, leaving a nonfunctional checkout page
					 * with a greyed-out blocked Pay button.
					 * You can test this by out-commenting the payment call in our 'onCheckoutSuccess' observer.
					 *
					 * Now:
					 * Our WC backend cannot dictate a redirectUrl because we will only start the client-side CHARGE
					 * after creating the order in the backend. Thus, the backend only finalizes LIST data.
					 * It is the job of the WebSDK to carry out the payment and handle the redirects.
					 * On the happy path, this is not an issue.
					 *
					 * But what if there is an error?
					 * component.pay() is async, but onCheckoutSuccess() can only be influenced synchronously, by returning
					 * success/failure. But we cannot know that since we are not omniscient time-bending 4D creatures yet.
					 *
					 * So since we cannot give WC any meaningful signal before resolving the async call,
					 * we are forced to accept its default behaviour: redirecting to 'redirectUrl' which is empty,
					 * leading to the aforementioned blocked checkout state.
					 *
					 * The only known recovery is dispatch(CHECKOUT_STORE_KEY).__internalSetIdle()
					 * However, that's using an internal function that might be unsafe and could be removed any time.
					 *
					 * So we're picking the heavy tools when they are required. Hints and PRs welcome.
					 *
					 * @see https://developer.woocommerce.com/docs/cart-and-checkout-checkout-flow-and-events/
					 */
					window.location.reload();
					return true // just out of spite
				}
			);
		},
		false
	);
}

export const initBlockCheckout = () => {
	console.log('Loading classic checkout integration')
	setUpBlockCheckoutListeners();
	setUpGatewayContainers();
	registerPageReloadingOnPaymentDeclined();
}
